module.exports = __webpack_public_path__ + "static/media/0019.47f85404.svg";